(function () {
    'use strict';

    angular
        .module('app.settings')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings',
                config: {
                    settings: {
                        hasChildren: true,
                        isVisible: true,
                        nav: 10,
                        content: '<i class= "fa fa-wrench" ></i> Settings<span class="indicator"></span>',
                        children: [
                            {
                                state: 'settings.category',
                                content: '<i class="fa "></i> User Categories'                               
                            },
                            {
                                state: 'settings.usertype',
                                content: '<i class="fa "></i> User Types'                                
                            }
                        ]
                    },                   
                    data: {
                        permissions: {
                            only: ['SSO:SysAdmin'],
                            redirectTo: function () {
                                return {
                                    state: 'error.403',
                                    options: {
                                        reload: true
                                    }
                                };
                            }
                        }
                    }
                }
            }           
        ];
    }
})();
